module.exports = {"230110001":"香坊大街街道","230110002":"安埠街道","230110003":"通天街道","230110004":"新香坊街道","230110005":"铁东街道","230110006":"新成街道","230110007":"红旗街道","230110008":"六顺街道","230110009":"建筑街道","230110010":"哈平路街道","230110011":"安乐街道","230110012":"健康路街道","230110013":"大庆路街道","230110014":"进乡街道","230110015":"通乡街道","230110016":"和平路街道","230110017":"民生路街道","230110018":"文政街道","230110019":"王兆街道","230110020":"黎明街道","230110101":"成高子镇","230110102":"幸福镇","230110103":"朝阳镇","230110104":"向阳镇","230110500":"香坊实验农场","230110579":"香坊区农垦"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230110.json
// module id = 620
// module chunks = 0